<template>
  <button
    type="button"
    role="switch"
    :id="id"
    :aria-checked="modelValue"
    :disabled="disabled"
    @click="$emit('update:modelValue', !modelValue)"
    :class="[
      'relative inline-flex h-5 w-9 flex-shrink-0 items-center rounded-full transition-colors disabled:opacity-40 disabled:cursor-not-allowed',
      modelValue ? 'bg-blue-600' : 'bg-stroke-strong dark:bg-stroke-strong-dark'
    ]"
  >
    <span
      :class="[
        'inline-block h-3.5 w-3.5 transform rounded-full bg-white transition-transform',
        modelValue ? 'translate-x-4' : 'translate-x-1'
      ]"
    />
  </button>
</template>

<script setup>
defineProps({
  modelValue: { type: Boolean, default: false },
  id: { type: String, default: undefined },
  disabled: { type: Boolean, default: false },
})
defineEmits(['update:modelValue'])
</script>
